import { useState } from "react";

export default function AdminSettingsPage() {
  const [activeTab, setActiveTab] = useState<"company" | "system" | "notifications">("company");
  const [saved, setSaved] = useState(false);

  const [company, setCompany] = useState({
    name: "ART POS Ticaret A.Ş.",
    taxNumber: "1234567890",
    taxOffice: "İstanbul Vergi Dairesi",
    address: "Maslak Mah. Büyükdere Cad. No:123 Şişli / İstanbul",
    phone: "0212 444 00 01",
    email: "info@artpos.com",
    website: "www.artpos.com",
  });

  const [settings, setSettings] = useState({
    currency: "TL",
    language: "tr",
    timezone: "Europe/Istanbul",
    defaultVatRate: 20,
    lowStockAlert: 5,
    autoBackup: true,
    backupTime: "23:00",
    sessionTimeout: 30,
  });

  const [notifications, setNotifications] = useState({
    emailNewSale: true,
    emailLowStock: true,
    emailDailyReport: false,
    emailWeeklyReport: true,
    smsNewSale: false,
    systemMaintenanceAlert: true,
  });

  const handleSave = () => {
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  const tabs = [
    { key: "company" as const, label: "Firma Bilgileri", icon: "ri-building-line" },
    { key: "system" as const, label: "Sistem Ayarları", icon: "ri-settings-3-line" },
    { key: "notifications" as const, label: "Bildirimler", icon: "ri-notification-3-line" },
  ];

  return (
    <div className="max-w-3xl mx-auto">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
        <div>
          <h4 className="text-lg font-semibold text-foreground-950"><a id="admin-settings-title">Sistem Ayarları</a></h4>
          <p className="text-sm text-foreground-500 mt-0.5">Sistem yapılandırmasını buradan yönetin</p>
        </div>
        <button onClick={handleSave} className="flex items-center gap-2 px-4 py-2 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap">
          <i className="ri-save-line"></i> {saved ? "Kaydedildi!" : "Kaydet"}
        </button>
      </div>

      {saved && (
        <div className="mb-4 px-4 py-3 bg-primary-100 text-primary-700 rounded-lg text-sm flex items-center gap-2">
          <i className="ri-checkbox-circle-line"></i> Ayarlar başarıyla kaydedildi.
        </div>
      )}

      <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
        <div className="flex border-b border-background-200/70 px-1 py-1">
          {tabs.map((tab) => (
            <button key={tab.key} onClick={() => setActiveTab(tab.key)} className={`flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${activeTab === tab.key ? "bg-secondary-100 text-secondary-700" : "text-foreground-500 hover:text-foreground-700 hover:bg-background-100"}`}>
              <i className={tab.icon}></i> {tab.label}
            </button>
          ))}
        </div>

        <div className="p-6">
          {activeTab === "company" && (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="sm:col-span-2">
                <label className="block text-xs font-medium text-foreground-500 mb-1">Firma Adı</label>
                <input type="text" value={company.name} onChange={(e) => setCompany({ ...company, name: e.target.value })} className="w-full px-3 py-2.5 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400" />
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-500 mb-1">Vergi Numarası</label>
                <input type="text" value={company.taxNumber} onChange={(e) => setCompany({ ...company, taxNumber: e.target.value })} className="w-full px-3 py-2.5 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400" />
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-500 mb-1">Vergi Dairesi</label>
                <input type="text" value={company.taxOffice} onChange={(e) => setCompany({ ...company, taxOffice: e.target.value })} className="w-full px-3 py-2.5 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400" />
              </div>
              <div className="sm:col-span-2">
                <label className="block text-xs font-medium text-foreground-500 mb-1">Adres</label>
                <textarea value={company.address} onChange={(e) => setCompany({ ...company, address: e.target.value })} rows={2} className="w-full px-3 py-2.5 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400 resize-none" />
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-500 mb-1">Telefon</label>
                <input type="text" value={company.phone} onChange={(e) => setCompany({ ...company, phone: e.target.value })} className="w-full px-3 py-2.5 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400" />
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-500 mb-1">E-posta</label>
                <input type="email" value={company.email} onChange={(e) => setCompany({ ...company, email: e.target.value })} className="w-full px-3 py-2.5 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400" />
              </div>
              <div className="sm:col-span-2">
                <label className="block text-xs font-medium text-foreground-500 mb-1">Web Sitesi</label>
                <input type="text" value={company.website} onChange={(e) => setCompany({ ...company, website: e.target.value })} className="w-full px-3 py-2.5 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400" />
              </div>
            </div>
          )}

          {activeTab === "system" && (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-medium text-foreground-500 mb-1">Para Birimi</label>
                <select value={settings.currency} onChange={(e) => setSettings({ ...settings, currency: e.target.value })} className="w-full px-3 py-2.5 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400 cursor-pointer">
                  <option value="TL">TL (Türk Lirası)</option>
                  <option value="USD">USD (Dolar)</option>
                  <option value="EUR">EUR (Euro)</option>
                </select>
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-500 mb-1">Dil</label>
                <select value={settings.language} onChange={(e) => setSettings({ ...settings, language: e.target.value })} className="w-full px-3 py-2.5 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400 cursor-pointer">
                  <option value="tr">Türkçe</option>
                  <option value="en">English</option>
                </select>
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-500 mb-1">Zaman Dilimi</label>
                <select value={settings.timezone} onChange={(e) => setSettings({ ...settings, timezone: e.target.value })} className="w-full px-3 py-2.5 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400 cursor-pointer">
                  <option value="Europe/Istanbul">Europe/Istanbul (GMT+3)</option>
                  <option value="Europe/London">Europe/London (GMT+0)</option>
                  <option value="America/New_York">America/New York (GMT-5)</option>
                </select>
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-500 mb-1">Varsayılan KDV Oranı (%)</label>
                <input type="number" value={settings.defaultVatRate} onChange={(e) => setSettings({ ...settings, defaultVatRate: Number(e.target.value) })} className="w-full px-3 py-2.5 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400" />
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-500 mb-1">Düşük Stok Uyarı Limiti</label>
                <input type="number" value={settings.lowStockAlert} onChange={(e) => setSettings({ ...settings, lowStockAlert: Number(e.target.value) })} className="w-full px-3 py-2.5 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400" />
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-500 mb-1">Oturum Zaman Aşımı (dakika)</label>
                <input type="number" value={settings.sessionTimeout} onChange={(e) => setSettings({ ...settings, sessionTimeout: Number(e.target.value) })} className="w-full px-3 py-2.5 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400" />
              </div>
              <div className="sm:col-span-2 pt-2 border-t border-background-200/70">
                <div className="flex items-center justify-between py-2">
                  <div>
                    <p className="text-sm font-medium text-foreground-900">Otomatik Yedekleme</p>
                    <p className="text-xs text-foreground-500">Her gece otomatik veritabanı yedeklemesi</p>
                  </div>
                  <button onClick={() => setSettings({ ...settings, autoBackup: !settings.autoBackup })} className={`relative w-11 h-6 rounded-full transition-colors cursor-pointer ${settings.autoBackup ? "bg-primary-500" : "bg-background-300"}`}>
                    <span className={`absolute top-0.5 w-5 h-5 rounded-full bg-background-50 transition-transform ${settings.autoBackup ? "left-[22px]" : "left-0.5"}`}></span>
                  </button>
                </div>
                {settings.autoBackup && (
                  <div className="mt-2">
                    <label className="block text-xs font-medium text-foreground-500 mb-1">Yedekleme Saati</label>
                    <input type="time" value={settings.backupTime} onChange={(e) => setSettings({ ...settings, backupTime: e.target.value })} className="px-3 py-2.5 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400" />
                  </div>
                )}
              </div>
            </div>
          )}

          {activeTab === "notifications" && (
            <div className="space-y-1">
              {[
                { key: "emailNewSale" as const, title: "Yeni Satış Bildirimi (E-posta)", desc: "Her yeni satış işleminde e-posta bildirimi gönder" },
                { key: "emailLowStock" as const, title: "Düşük Stok Uyarısı (E-posta)", desc: "Stok limitin altına düştüğünde e-posta bildirimi gönder" },
                { key: "emailDailyReport" as const, title: "Günlük Rapor (E-posta)", desc: "Her gün satış özeti e-postası gönder" },
                { key: "emailWeeklyReport" as const, title: "Haftalık Rapor (E-posta)", desc: "Her hafta başında haftalık rapor e-postası gönder" },
                { key: "smsNewSale" as const, title: "Yeni Satış Bildirimi (SMS)", desc: "Yüksek tutarlı satışlarda SMS bildirimi gönder" },
                { key: "systemMaintenanceAlert" as const, title: "Sistem Bakım Uyarısı", desc: "Planlı bakım çalışmaları öncesinde bildirim gönder" },
              ].map((item) => (
                <div key={item.key} className="flex items-center justify-between py-3 px-3 rounded-lg hover:bg-background-100/50 transition-colors">
                  <div>
                    <p className="text-sm font-medium text-foreground-900">{item.title}</p>
                    <p className="text-xs text-foreground-500">{item.desc}</p>
                  </div>
                  <button onClick={() => setNotifications({ ...notifications, [item.key]: !notifications[item.key] })} className={`relative w-11 h-6 rounded-full transition-colors shrink-0 cursor-pointer ${notifications[item.key] ? "bg-primary-500" : "bg-background-300"}`}>
                    <span className={`absolute top-0.5 w-5 h-5 rounded-full bg-background-50 transition-transform ${notifications[item.key] ? "left-[22px]" : "left-0.5"}`}></span>
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}